import { removeUndefinedAttributes } from 'util/remove-undefined-attributes';
import { IOSGIConfig } from '../interfaces';

export const shellConfigs = (
	OSGIconfig: IOSGIConfig['shellConfig'],
	overrideConfig?: IOSGIConfig['shellConfig']
) => {
	return removeUndefinedAttributes({
		abandonFormNotification:
			overrideConfig?.abandonFormNotification ??
			OSGIconfig?.abandonFormNotification,
		clearTokenOnInit:
			overrideConfig?.clearTokenOnInit ??
			OSGIconfig?.clearTokenOnInit,
		contentFragment:
			overrideConfig?.contentFragment ??
			OSGIconfig?.contentFragment,
		appConfig:
			overrideConfig?.appConfig ??
			OSGIconfig?.appConfig,
		renderLogin:
			overrideConfig?.renderLogin ??
			OSGIconfig?.renderLogin,
	});
};
